// extracted by mini-css-extract-plugin
export default {"responsiveBackground":"aCUSX8","borderRadius":"bCUSX8"};